<template>
  <button class="button" :title="action" type="button">
    <i v-if="source === 'download'" class="fas fa-cloud-download-alt"></i>
    <i v-if="source === 'print'" class="fas fa-print"></i>
    <i v-if="source === 'close'" class="fas fa-times"></i>
  </button>
</template>

<script>
import { XIcon } from 'vue-feather-icons'

export default {
  name: 'ToolbarButton',
  components: {},
  props: {
    source: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
.button {
  height: 42px;
  width: 42px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  outline: none;
  border: none;
  @include transition(150ms);
  background: transparent;

  svg {
    color: $color-light;
    font-size: 18px;

    &:hover {
      color: $color-yellow;
      @include transition(150ms);
    }
  }

  &:hover {
    background: none;

    path,
    line,
    polyline,
    rect,
    circle {
      @include transition(150ms);
      stroke: $theme;
    }
  }
}
</style>
